import { Suspense } from 'react'
import Field from '../../../../fields'
import EditProfileCard, { CardFields } from '../EditProfileCard'

type EmploymentCardProps = {
  fields: Record<string, any>
  formId: string
  teamMemberEnabled?: boolean
  accountFieldsOnly?: boolean
  testId?: string
}

const EmploymentCard = ({
  fields,
  formId,
  teamMemberEnabled,
  accountFieldsOnly = false,
  testId
}: EmploymentCardProps) => (
  <EditProfileCard title="Employment details" testId={testId}>
    <Suspense fallback={<div>Loading...</div>}>
      <CardFields>
        <Field
          className="startdate-field"
          keys="startDate"
          placeholders="DD-MM-YYYY"
          formId={formId}
          label="Start date"
          type="date"
          disabled={accountFieldsOnly}
          values={fields}
        />
        {teamMemberEnabled && (
          <Field
            className="enddate-field"
            keys="endDate"
            placeholders="DD-MM-YYYY"
            formId={formId}
            label="End date"
            type="date"
            disabled={accountFieldsOnly}
            values={fields}
          />
        )}
      </CardFields>
    </Suspense>
  </EditProfileCard>
)

export default EmploymentCard
